import axios from 'axios'
// import base from '../api/base.js'
import allUrl from '../api/allUrl.js'

// let hostname = window.location.hostname == 'localhost' ? 'lighting.lampmind.com' : window.location.hostname
// let url = "webConfig.json"
// let request = new XMLHttpRequest();
// request.open("get", url);
export default {
    websocket: (url, callback,) => {
        
        let websocket = null
        // console.log(this_)
        if ("WebSocket" in window) {
            
            websocket = new WebSocket(url);
        } else if ("MozWebSocket" in window) {
            websocket = new WebSocket(url);
        } else {
            console.error("'不支持 WebSocKet");
        }
        //连接发生错误的回调方法
        websocket.onerror = event => {
            // console.log(event)
            console.log("onerror",event);
            websocket.close()
            websocket = null
            if ("WebSocket" in window) {
                websocket = new WebSocket(url);
            } else if ("MozWebSocket" in window) {
                websocket = new WebSocket(url);
            }
            if(websocket){
                websocketOnopen(websocket)
            }
        }
        //接收到消息的回调方法
        websocketOnopen(websocket)
        function websocketOnopen(websocket) {
            let isTrue = true;
            websocket.onopen = () => {
                // console.log(error,'-159-')
                callback(websocket)

                // 监听服务端发送的消息
                websocket.addEventListener('message', function (event) {
                    // 处理服务端返回的数据
                    // if (data.topic == "/user/logout") {
                        
                    //   }
                    console.log('收到消息:', event.data);
                    // console.log(event.data[token],'--???----9')
                });

                //接收到消息的回调方法
                //连接关闭的回调方法
                // websocket.onclose = () => console.log("close");
                //监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接，防止连接还没断开就关闭窗口，server端会抛异常。
                window.onbeforeunload = () => websocket.close();
                //return websocket;
            };
            // websocket.onclose = event => {
            //     console.log("onclose",event);
            //     if(isTrue){
            //         isTrue = false;
            //         setTimeout(()=>{
            //             isTrue = true;
            //         },3000)
            //         websocket.close()
            //         websocket = null
            //         if ("WebSocket" in window) {
            //             websocket = new WebSocket(url);
            //         } else if ("MozWebSocket" in window) {
            //             websocket = new WebSocket(url);
            //         }
            //         if(websocket){
            //             websocketOnopen(websocket)
            //         }
            //     }
            // }
            //连接发生错误的回调方法
            websocket.onerror = event => {
                console.log('onclose',event)
                if(isTrue){
                    isTrue = false;
                    setTimeout(()=>{
                        isTrue = true;
                    },3000)
                    websocket.close()
                    websocket = null
                    if ("WebSocket" in window) {
                        websocket = new WebSocket(url);
                    } else if ("MozWebSocket" in window) {
                        websocket = new WebSocket(url);
                    }
                    if(websocket){
                        websocketOnopen(websocket)
                    }
                }
            }
        }

        return websocket;
    },
    websocket_sureLogin: (url ) => {
        url = allUrl.websocket.ws;
        console.log(url,'--999---')
        // url = protocol + '//' + 'iot.wemind.xyz:8888'
        // console.log(websocket,'-9595--')

        // const websocket = new WebSocket(url);
        // websocket.onopen = () => {
        //     console.log('WebSocket 连接已打开');
        //     // 发送数据
        //     websocket.send('Hello Server!');
        //     console.log('-9595--')
        //   };
        
        //   // 接收到消息时触发
        //   websocket.onmessage = (event) => {
        //     console.log('接收到消息:', event.data);
        // };
        // // 连接关闭时触发
        // websocket.onclose = (event) => {
        //     console.log('WebSocket 连接已关闭', event);
        // };
        
        // // 发生错误时触发
        // websocket.onerror = (error) => {
        //     console.error('WebSocket 发生错误:', error);
        // };
        
        // let websocket = null
        // if ("WebSocket" in window) {
        // // websocket = new WebSocket("ws://"+url);
        // websocket = new WebSocket(url);
        // console.log(websocket,'-888')
        // } else if ("MozWebSocket" in window) {
        // // websocket = new WebSocket("ws://"+url);
        // websocket = new WebSocket(url);
        // } else {
        // console.error("'不支持 WebSocKet");
        // }
        
        // //连接发生错误的回调方法
        // websocket.onerror = event => {
        // console.log(event,'--777')
        // websocket = null
        // if ("WebSocket" in window) {
        //     websocket = new WebSocket(url);
        // } else if ("MozWebSocket" in window) {
        //     websocket = new WebSocket(url);
        // }
        // if (websocket) {
        //     websocketOnopen(websocket)
        // }
        // }
        // websocketOnopen(websocket)
        // //接收到消息的回调方法
        // function websocketOnopen(websocket) {
        //     let isTrue = true;
        //     console.log(websocket,'-666')
        //     websocket.onopen = () => {
        //         // console.log(event,error)
        //         callback(websocket)
        //         //接收到消息的回调方法
        //         //连接关闭的回调方法
        //         // websocket.onclose = () => console.log("close");
        //         //监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接，防止连接还没断开就关闭窗口，server端会抛异常。
        //         // window.onbeforeunload = () => websocket.close();
        //         //return websocket;
        //     };
        //     // websocket.onclose = event => {
        //     //     console.log("onclose",event);
        //     //     if(isTrue){
        //     //         isTrue = false;
        //     //         setTimeout(()=>{
        //     //             isTrue = true;
        //     //         },3000)
        //     //         websocket.close()
        //     //         websocket = null
        //     //         if ("WebSocket" in window) {
        //     //             websocket = new WebSocket(url);
        //     //         } else if ("MozWebSocket" in window) {
        //     //             websocket = new WebSocket(url);
        //     //         }
        //     //         if(websocket){
        //     //             websocketOnopen(websocket)
        //     //         }
        //     //     }
        //     // }
        //     //连接发生错误的回调方法
        //     websocket.onerror = event => {
        //         console.log('onclose',event)
        //         if(isTrue){
        //             isTrue = false;
        //             setTimeout(()=>{
        //                 isTrue = true;
        //             },3000)
        //             websocket.close()
        //             websocket = null
        //             if ("WebSocket" in window) {
        //                 websocket = new WebSocket(url);
        //             } else if ("MozWebSocket" in window) {
        //                 websocket = new WebSocket(url);
        //             }
        //             if(websocket){
        //                 websocketOnopen(websocket)
        //             }
        //         }
        //     }
        // }

        // return websocket;
    },
    websocket_close: (url, callback,) => {
        
        let websocket = null
        // console.log(this_)
        if ("WebSocket" in window) {
            websocket = new WebSocket(url);
        } else if ("MozWebSocket" in window) {
            websocket = new WebSocket(url);
        } else {
            console.error("'不支持 WebSocKet");
        }
        //连接发生错误的回调方法
        websocket.onerror = event => {
            // console.log(event)
            console.log("onerror",event);
            websocket.close()
            websocket = null
            if ("WebSocket" in window) {
                websocket = new WebSocket(url);
            } else if ("MozWebSocket" in window) {
                websocket = new WebSocket(url);
            }
            if(websocket){
                websocketOnopen(websocket)
            }
        }
        //接收到消息的回调方法
        websocketOnopen(websocket)
        function websocketOnopen(websocket) {
            let isTrue = true;
            websocket.onopen = () => {
                // console.log(event,error)
                callback(websocket)
                //接收到消息的回调方法
                //连接关闭的回调方法
                // websocket.onclose = () => console.log("close");
                //监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接，防止连接还没断开就关闭窗口，server端会抛异常。
                window.onbeforeunload = () => websocket.close();
                //return websocket;
            };
            websocket.onclose = event => {
                console.log("onclose",event);
                if(isTrue){
                    isTrue = false;
                    setTimeout(()=>{
                        isTrue = true;
                    },3000)
                    websocket.close()
                    websocket = null
                    if ("WebSocket" in window) {
                        websocket = new WebSocket(url);
                    } else if ("MozWebSocket" in window) {
                        websocket = new WebSocket(url);
                    }
                    if(websocket){
                        websocketOnopen(websocket)
                    }
                }
            }
            //连接发生错误的回调方法
            websocket.onerror = event => {
                console.log('onclose',event)
                if(isTrue){
                    isTrue = false;
                    setTimeout(()=>{
                        isTrue = true;
                    },3000)
                    websocket.close()
                    websocket = null
                    if ("WebSocket" in window) {
                        websocket = new WebSocket(url);
                    } else if ("MozWebSocket" in window) {
                        websocket = new WebSocket(url);
                    }
                    if(websocket){
                        websocketOnopen(websocket)
                    }
                }
            }
        }

        return websocket;
    },

    ajax_get: (url, param, callback, this_) => {
        axios.get(url, { params: param }).then(res => {
            let data = res.data
            if (data.result) {
                if (callback) {
                    if (data.model && JSON.stringify(data.model).length > 2) {
                        try {
                            callback(data.model)
                        } catch (e) {
                            // console.log('异常了')
                            // console.log(e)
                        }
                    } else {
                        callback(data.model)
                    }
                }

            } else {
                this_.$alert(data.message, this_.$t('App.message.text26'));
            }
        })
    },
    ajax_post: (url, data, param, callback, this_, error, error_t) => {
        let qs = require('qs')
        data.version = this_.version;
        data.clientType = '0';
        axios.post(url, qs.stringify(data), { params: param }).then(res => {
            let data = res.data
            // console.log(data)
            if (data.code == '00000'||data.code == '10014') {
                if (callback) {
                    callback(data, this_)
                }
            } else if (data.code == '00001' || data.code == '00002' || data.code == '00003' || data.code == '00004' || data.code == '00006' || data.code == '10006') {
                if (error) {
                    error(data, this_)
                }
                let storage = window.localStorage;
                if(storage.getItem('userData')&&data.code != '10006'){
                    this_.$alert(data.msg, this_.$t('App.message.text1'), {
                        confirmButtonText: this_.$t('App.message.text2'),
                    });
                }
                var oDate = new Date();
                oDate.setTime(oDate.getTime() + ('' * 24 * 60 * 60 * 1000));
                oDate = oDate.toUTCString()
                document.cookie = 'userData' + '=' + '' + ';expires=' + oDate;
                this_.$store.commit('ROUTERSTRFUN',{
                  routerStr:'/login',
                })
                this_.$router.push({path:'/login'})

                // if(this_.websocket){
                //   this_.websocket.close();
                // }
            } else {
                if (error) {
                    error(data, this_)
                }
                if (!error_t) {
                    console.log(url,this_)
                    this_.$alert(data.msg, this_.$t('App.message.text1'), {
                        confirmButtonText: this_.$t('App.message.text2'),
                    });
                }
            }
        })
    },
    ajax_postWs: (url, data, this_,) => {
        let qs = require('qs')
        data.version = this_.version;
        data.clientType = '0';
        axios.post(url, qs.stringify(data)).then(() => {})
    },

    setCookie: (key, value, iDay) => {
        var oDate = new Date();
        oDate.setTime(oDate.getTime() + (iDay * 24 * 60 * 60 * 1000));
        oDate = oDate.toUTCString();
        // document.cookie = key + '=' + value;
        // console.log(key + '=' + value + ';expires=' + oDate)
        document.cookie = key + '=' + value + ';expires=' + oDate;
    },
    // removeCookie: (key) => {
    //     setCookie(key, '', -1); //这里只需要把Cookie保质期退回一天便可以删除
    // },
    getCookie: (key) => {
        var cookieArr = document.cookie.split('; ');
        for (var i = 0; i < cookieArr.length; i++) {
            var arr = cookieArr[i].split('=');
            if (arr[0] === key) {
                return arr[1];
            }
        }
        return false;
    },
    download (url) {
        try {
            var elemIF = document.createElement("iframe");
            elemIF.src = url;
            elemIF.style.display = "none";
            document.body.appendChild(elemIF);
        } catch (e) {
            alert("下载异常！");
        }
    },
}